var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.svgSource || _vm.tier.iconEmoji)?_c('span',{staticClass:"tier-icon",attrs:{"aria-hidden":"true"}},[(_vm.svgSource)?_c('img',{attrs:{"src":_vm.svgSource,"alt":""}}):[_vm._v(_vm._s(_vm.tier.iconEmoji))]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }